
import { renderRichText } from '@storyblok/js';
export default function (
  { _uid, _editable, text, texthadow, fontSizeMobile, fontSizeTablet, fontSizeDesktop }
) {
  return {
    module: 'SBannerContent',
    _uid,
    _editable,
    text: renderRichText(text),
    texthadow,
    fontSizeMobile,
    fontSizeTablet,
    fontSizeDesktop
  };
}
